import Prismic from "prismic-javascript";
import { PRISMIC_API_URL } from "../utils/config";
import getCookies from "next-cookies";
import { toParamsString } from "../utils/to-params-string";

const isServer = typeof window === "undefined";
let _cache = {};
let _cachedAPI = false;

const getPrismic = async ({
  context,
  fragment,
  value,
  multiple = false,
  options = {},
  customPredicate,
  customPredicateKey
}) => {
  try {
    // Allow user to add a completely different predicate
    let p;
    let cache_key;
    if (!customPredicate) {
      p = Prismic.Predicates.at(fragment, value);
      cache_key = `${fragment}:${value}${
        Object.keys(options).length > 0 ? ":" + toParamsString(options) : ""
      }`;
    } else {
      p = customPredicate;
      cache_key = customPredicateKey;
    }
    const cookies = getCookies(context);
    const ref = cookies["io.prismic.preview"];
    if (!_cachedAPI || isServer) {
      _cachedAPI = await Prismic.api(PRISMIC_API_URL, {
        accessToken: 'MC5YS3ZlRWhJQUFPcHgzWW9l.77-977-9Lu-_vXPvv70077-9MkAv77-9dioIN--_ve-_ve-_vRBz77-9K--_vUrvv71d77-9R--_vSlJ'
      });
    }
    if (!_cache[cache_key] || isServer) {
      const response = await _cachedAPI.query(p, { ref, ...options });
      _cache[cache_key] = multiple ? response.results : response.results[0];
    }

    return _cache[cache_key];
  } catch (error) {
    console.error(error);
    return error;
  }
};

export { getPrismic };
